 function isStorageAvailable(type) {
    try {
      const storage = window[type];
      const testKey = '__storage_test__';
      storage.setItem(testKey, testKey);
      storage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  if (isStorageAvailable('localStorage')) {
    console.log('LocalStorage is available');
    // Use localStorage
  } else {
    console.log('Fallback storage will be used');
    // Use a fallback, e.g., cookies or in-memory storage
  }